<template>
  <b-modal
    id="cancel-order-success"
    :no-close-on-backdrop="true"
    :hide-header="true"
    size="sm"
    centered
    footer-class="border-top-0 d-flex justify-content-center py-4"
    body-class="pt-5 text-center pb-0"
    dialog-class="mx-auto">
    <img src="@/assets/images/ic-check-circle.svg" alt="Cancel Order Success" class="img-fluid mb-3">
    <p class="mt-0 text-center" v-if="cancelledOrderMsg">{{ cancelledOrderMsg.message }}</p>
    <template slot="modal-footer">
      <b-button
        variant="primary"
        class="border-0 w-100 text-uppercase"
        pill
        :style="{
          backgroundColor:
            webDesign && webDesign.design ? `${webDesign.design.main_color} !important` : null,
          color:
            webDesign && webDesign.design ? `${webDesign.design.button_text_color} !important` : null,
        }"
        @click="handleDone">
        Done
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { mapState, mapGetters } from "vuex";

export default {
  name: "CancelOrderSuccess",
  computed: {
    ...mapGetters({
      cancelledOrderMsg: "estore/cancelledOrderMsg",
      loggedIn: "auth/loggedIn",
    }),
    ...mapState("estore", {
      webDesign: state => state.webDesign
    })
  },
  methods: {
    handleDone() {
      this.$root.$emit("bv::hide::modal", "cancel-order-success");
                  
      if (this.loggedIn)
        this.$router.push({ name: "Orders" });
      else
        location.reload();
    }
  }
}
</script>

<style lang="scss">
#cancel-order-success {
  .modal-dialog {
    max-width: 338px !important;
  }
  .btn-primary {
    height: 50px;
  }
}
</style>
